import { Config } from '@/config'

export function backgroundImage(image: string, width?: number, height?: number) {
  let style = ''

  if (image !== undefined) {
    style = `background-image: url("${imageUrl(image, width, height)}"); `
  }

  return style
}

export function dummyImage(width: number, height: number, text: string) {
  return `https://dummyimage.com/${width}x${height}/aaaaaa/fff.jpg&text=${decodeURIComponent(text)}`
}

export function imageUrl(image?: string, width?: number, height?: number) {
  let url: string

  if (image !== undefined) {
    url = image

    if (isDataUrl(image) === false) {
      if (/^https?/.test(url) === false) {
        if (/^[0-9a-z]*\.(png|jpe?g|gif)/.test(url)) {
          url = `${Config.ImageBaseUrl}/${image}`
        }
      }

      if (width !== undefined && height !== undefined) {
        url += `?width=${width}&height=${height}`
      } else if (width !== undefined) {
        url += `?width=${width}`
      } else if (height !== undefined) {
        url += `?height=${height}`
      }
    }
  } else {
    url = '' // dummyImage(width || 200, height || 200, 'dummy')
  }

  return url
}

function isDataUrl(image: string): boolean {
  return image.indexOf('data:image') === 0
}
